import badgeReferAFriend from 'assets/images/checkout/badge-raf.svg';
import badgeSkincareMinis from 'assets/images/checkout/badge-skincare-minis.svg';
import badgeSkincareMinis2 from 'assets/images/checkout/badge-skincare-minis-2.svg';
import badgeTrialOffer from 'assets/images/checkout/badge-trial-offer.svg';
import haircareTrialOfferDesktopImg from 'assets/images/checkout/haircare-trial-offer-desktop.jpg';
import haircareTrialOfferMobileImg from 'assets/images/checkout/haircare-trial-offer-mobile.jpg';
import rafDesktopImg from 'assets/images/checkout/raf-desktop.jpg';
import rafMobileImg from 'assets/images/checkout/raf-mobile.jpg';
import skincareMinisDesktopImg from 'assets/images/checkout/skincare-minis-desktop.jpg';
import skincareMinisMobileImg from 'assets/images/checkout/skincare-minis-mobile.jpg';
import skincareTrialOfferDesktopImg from 'assets/images/checkout/skincare-trial-offer-desktop.jpg';
import skincareTrialOfferMobileImg from 'assets/images/checkout/skincare-trial-offer-mobile.jpg';

export const skincareMinis = {
  US: {
    'tracking.pageView': 'Post Purchase - SK Minis Embedded Module - Viewed',
    title: 'Free Skincare Starter Set',
    description: 'Get a trial-size routine ($65 value) when you subscribe to skincare.',
    benefits: null,
    'cta.consultationNotCompleted.label': 'Get your free routine',
    'cta.consultationNotCompleted.path': '/consultation/skincare',
    'cta.consultationNotCompleted.dataFrom': 'post-purchase-skincare-minis-offer-embedded-module',
    'cta.consultationNotCompleted.dataClick': 'offer-cta',
    'cta.consultationCompleted.label': 'Get your free routine',
    'cta.consultationCompleted.path': '/checkout/skincare',
    'cta.consultationCompleted.dataFrom': 'post-purchase-skincare-minis-offer-embedded-module',
    'cta.consultationCompleted.dataClick': 'offer-cta',
    'image.desktop': skincareMinisDesktopImg,
    'image.mobile': skincareMinisMobileImg,
    badge: badgeSkincareMinis,
  },
  CA: {
    description: 'Get a trial-size routine when you subscribe to skincare.',
    badge: badgeSkincareMinis2,
  },
};

export const haircareTrialOffer = {
  US: {
    'tracking.pageView': 'Post Purchase - HC Trial Offer Embedded Module - Viewed',
    title: 'Custom haircare that’s tried, tested, and shown effective for:',
    description: null,
    benefits: ['volume', 'shine', 'smoothness', 'curl definition', 'moisture'],
    'cta.consultationNotCompleted.label': 'Get my haircare formula',
    'cta.consultationNotCompleted.path': '/consultation/haircare',
    'cta.consultationNotCompleted.dataFrom': 'post-purchase-haircare-trial-offer-embedded-module',
    'cta.consultationNotCompleted.dataClick': 'get-offer',
    'cta.consultationCompleted.label': 'Order my prose',
    'cta.consultationCompleted.path': '/checkout/haircare',
    'cta.consultationCompleted.dataFrom': 'post-purchase-haircare-trial-offer-embedded-module',
    'cta.consultationCompleted.dataClick': 'get-offer',
    'image.desktop': haircareTrialOfferDesktopImg,
    'image.mobile': haircareTrialOfferMobileImg,
    badge: badgeTrialOffer,
  },
};

export const skincareTrialOffer = {
  US: {
    'tracking.pageView': 'Post Purchase - SK Trial Offer Embedded Module - Viewed',
    title: 'Custom skincare that’s tried, tested, and shown effective for:',
    description: null,
    benefits: ['fine lines', 'wrinkles', 'breakouts', 'blemishes', 'clogged pores', 'blackheads'],
    'cta.consultationNotCompleted.label': 'Get my skincare formula',
    'cta.consultationNotCompleted.path': '/consultation/skincare',
    'cta.consultationNotCompleted.dataFrom': 'post-purchase-skincare-trial-offer-embedded-module',
    'cta.consultationNotCompleted.dataClick': 'get-offer',
    'cta.consultationCompleted.label': 'Order my prose',
    'cta.consultationCompleted.path': '/checkout/skincare',
    'cta.consultationCompleted.dataFrom': 'post-purchase-skincare-trial-offer-embedded-module',
    'cta.consultationCompleted.dataClick': 'get-offer',
    'image.desktop': skincareTrialOfferDesktopImg,
    'image.mobile': skincareTrialOfferMobileImg,
    badge: badgeTrialOffer,
  },
};

export const referAFriend = {
  US: {
    'tracking.pageView': 'Post Purchase Refer A Friend Offer Embedded Module - View',
    title: 'Give $20, get $20',
    description: 'Refer your friends to Prose with $20 off — and you’ll get $20 off too.',
    benefits: null,
    'cta.default.label': 'Share Prose',
    'cta.default.path': '/account/refer-a-friend',
    'cta.default.dataFrom': 'post-purchase-refer-a-friend-offer-embedded-module',
    'cta.default.dataClick': 'refer',
    'image.desktop': rafDesktopImg,
    'image.mobile': rafMobileImg,
    badge: badgeReferAFriend,
  },
};
